import React, { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Descriptions, Spin, message, Tabs, Button, Collapse } from "antd";
import { EntityCommonInfoModel } from "../../entities/common";
import { DateTimeViewer } from "..";
import { CommonMergeModel } from "../../entities/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

interface IndexPageHeaderWithMergeProps {
  title: string;
  query: Function;
  mergeMutation: Function;
  merger: (mergerCallback: (data: CommonMergeModel) => Promise<boolean>) => JSX.Element;
}

export const IndexPageHeaderWithMerge = memo(({ title, query, mergeMutation, merger }: IndexPageHeaderWithMergeProps) => {
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = query();

  const [mergeRecords] = mergeMutation();

  const merge = useCallback(
    async (model: CommonMergeModel) => {
      try {
        message.loading({
          content: "در حال ادغام",
          key: "mergeRecords",
          duration: 0,
        });

        await mergeRecords(model).unwrap();

        message.success({
          content: "ادغام رکوردها با موفقیت انجام شد",
          key: "mergeRecords",
          duration: 5,
        });

        return true;
      } catch {
        message.error({
          content: "ادغام رکوردها با خطا مواجه شد",
          key: "mergeRecords",
          duration: 5,
        });

        return false;
      }
    },
    [mergeRecords]
  );

  const info = useMemo<EntityCommonInfoModel>(
    () => ({
      totalRecords: data?.totalRecords ?? 0,
      lastCreateAt: data?.lastCreateAt ?? "",
      lastUpdateAt: data?.lastUpdateAt ?? "",
    }),
    [data]
  );

  return (
    <Collapse>
      <Collapse.Panel
        key="1"
        header={<span className="text-lg">{title}</span>}
        extra={[
          <Button key="1" type="primary" onClick={() => navigate("new")} icon={<FontAwesomeIcon className="anticon align-middle" icon={faPlus} />}>
            جدید
          </Button>,
        ]}>
        <Spin spinning={isLoading || isFetching}>
          <Tabs defaultActiveKey="1" tabPosition="top">
            <Tabs.TabPane tab="اطلاعات کلی" key="info">
              <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
                <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
                  {info.totalRecords}
                </Descriptions.Item>
                <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
                  <DateTimeViewer value={info.lastCreateAt} mode="distance" />
                </Descriptions.Item>
                <Descriptions.Item label="آخرین ویرایش" labelStyle={{ color: "gray" }}>
                  <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
                </Descriptions.Item>
              </Descriptions>
            </Tabs.TabPane>
            <Tabs.TabPane tab="ادغام" key="merge">
              {merger(merge)}
            </Tabs.TabPane>
          </Tabs>
        </Spin>
      </Collapse.Panel>
    </Collapse>
  );
});
